import { IconType, SvgIcon } from './SvgIcon';

export const Back15Icon: IconType = (props) => (
  <SvgIcon {...props} fill="none" viewBox="5 2 15 21">
    <path
      d="M5.66599 14.5495C5.97139 16.0011 6.70037 17.3295 7.76076 18.3668C8.82115 19.4041 10.1653 20.1036 11.6233 20.3769C13.0812 20.6503 14.5875 20.4851 15.9516 19.9024C17.3157 19.3197 18.4764 18.3456 19.2869 17.1032C20.0973 15.8608 20.5212 14.406 20.5049 12.9227C20.4885 11.4395 20.0327 9.99436 19.195 8.77014C18.3574 7.54593 17.1755 6.5976 15.7989 6.04508C13.8502 5.27141 11.6778 5.28106 9.73593 6.072L7.28662 7.1183"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.83862 3.25146L7.28662 7.1183L11.1534 8.6703"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4546 16V12.059L9.58663 12.283V11.632L10.7906 11.1H11.3156V16H10.4546ZM14.0222 16.084C13.6722 16.084 13.3689 16.0233 13.1122 15.902C12.8602 15.776 12.6619 15.6057 12.5172 15.391C12.3726 15.1717 12.2862 14.9243 12.2582 14.649H13.0772C13.1192 14.8543 13.2242 15.027 13.3922 15.167C13.5602 15.3023 13.7702 15.37 14.0222 15.37C14.2136 15.37 14.3769 15.3257 14.5122 15.237C14.6476 15.1437 14.7526 15.02 14.8272 14.866C14.9066 14.7073 14.9462 14.53 14.9462 14.334C14.9462 14.1333 14.9066 13.9583 14.8272 13.809C14.7526 13.6597 14.6476 13.5453 14.5122 13.466C14.3769 13.382 14.2206 13.34 14.0432 13.34C13.8239 13.34 13.6349 13.3913 13.4762 13.494C13.3222 13.592 13.2102 13.7157 13.1402 13.865H12.3282L12.7342 11.1H15.4362V11.835H13.3642L13.1402 13.046C13.2476 12.9293 13.3899 12.836 13.5672 12.766C13.7446 12.6913 13.9476 12.654 14.1762 12.654C14.4329 12.654 14.6592 12.6983 14.8552 12.787C15.0512 12.8757 15.2169 12.997 15.3522 13.151C15.4876 13.305 15.5879 13.4847 15.6532 13.69C15.7232 13.8907 15.7582 14.103 15.7582 14.327C15.7582 14.579 15.7162 14.8123 15.6322 15.027C15.5482 15.237 15.4292 15.4213 15.2752 15.58C15.1259 15.7387 14.9439 15.8623 14.7292 15.951C14.5192 16.0397 14.2836 16.084 14.0222 16.084Z"
      fill="currentColor"
    />
  </SvgIcon>
);

Back15Icon.displayName = 'Back15Icon';
